export type InputField = {
  name: string;
  title: string;
  type: string;
  sensitive: boolean;
  value: string;
};
